import store from '@/store'

const authenticated = (to, from, next) => {
  // must be logged in
  const token = store.getters['AUTH/token']
  const tokenPresent = token !== null

  if (tokenPresent) {
    store.dispatch('AUTH/FETCH_USER', token)
      .then(() => {
        next()
      })
      .catch(() => {
        store.dispatch('AUTH/RESET_USER').then(() => {
          next('/login')
        })
      })
  } else {
    next('/login')
  }
}

export default authenticated



// WEBPACK FOOTER //
// ./src/router/guards/authenticated.js